import React from "react";
import { useTranslation } from "react-i18next";
import { t_help } from "@i18n/usualTexts/t_help";

interface RequiredFieldIndicatorProps {
  required?: boolean;
  className?: string;
}

const RequiredFieldIndicator: React.FC<RequiredFieldIndicatorProps> = ({
  required = false,
  className = "",
}) => {
  const { t } = useTranslation();

  if (!required) return null;

  const requiredFieldText = t(t_help.requiredField);

  return (
    <span
      className={`text-red-500 font-bold ${className}`}
      aria-label={requiredFieldText}
      title={requiredFieldText}
    >
      *
    </span>
  );
};

export default RequiredFieldIndicator;
